export enum ChartType {
  Distribution = 0,
  Trend = 1,
  Comparison360 = 2,
  Table = 3,
  Spider = 4,
  VerticalColorful = 5,
  HorizontalStacked = 6,
  VerticalStacked = 7,
  HorizontalColorful = 8,
}
